import { getUnownedCentresOfUserApi } from 'api/user';
import { getAllCustom } from 'redux/crudCreatorCustom/actions';

export const MODEL_NAME = 'unownedCentresOfUser';

export const getUnownedCentresOfUser = getAllCustom(
  MODEL_NAME,
  getUnownedCentresOfUserApi,
);
